import PropTypes from 'prop-types';

import { ROUTE_NODES } from '@/common/constants';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const BreadcrumbDefaultProps = {
  ...ClassNameDefaultProps,
  backIcon: null,
  breadcrumb: [],
  depth: null,
  navigable: false,
  route: ROUTE_NODES,
  linkEnableIndex: 0,
};

export const BreadcrumbPropTypes = {
  ...ClassNamePropTypes,
  backIcon: PropTypes.element,
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
      path: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  depth: PropTypes.number,
  navigable: PropTypes.bool,
  route: PropTypes.string,
  linkEnableIndex: PropTypes.number,
};
